// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const billingClient = createTypedClient();
export const createBillingClient = (config) => createTypedClient(config);
